import {SActionBtn, SIDRender, SLowcodeList, STableActions} from "shj-components";
import config from "./config.tsx";
import {useEffect, useRef, } from "react";
import {getAuth} from "@/utils/auth.ts";
import {message, Tag} from "antd";
import CheckThePhone from "@/components/CheckThePhone";
import {useNavigate} from "react-router-dom";
import {salesWorkPage} from "@/services/saleOpServices.ts";
import {apiData2Table} from "@/utils/data.ts";
import {useSetState} from "ahooks";
import wx_add from '@/assets/wx_add.svg'
import wx_add_ok from '@/assets/wx_add_ok.svg'
import {isEmpty} from "lodash-es";
import {getUser} from "shj-utils";
import {PhoneFilled} from "@ant-design/icons";
import ClueCallModal from "@/pages/salesWorkbench/workbenchList/components/clueCallModal";
import styles from '@/pages/salesWorkbench/workbenchList/index.module.less'
import {getSeatAccount, getSeatAccountOne} from "@/services/crmTool.ts";
import {callBatchReceive} from "@/services/callCenter";
import {openInNewTab} from "@/utils/queryParse.ts";

const CallPublicInfo = (props) => {
  const navigate = useNavigate()
  const listRef = useRef<any>()
  const {ucenterUserId} = getUser()
  const [state, setState] = useSetState({
    open: false,
    record: {},
    id: '',
    callModalOpen: false,
    callClueId: '',
    isSeat: false,
    clueBtnLoading: false,
  })

  useEffect(() => {
    getSeatAccountOne({userId: ucenterUserId, brand: 'HELI' }).then(res => {
      setState({isSeat: !isEmpty(res)})
    })
  }, [ucenterUserId]);

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      salesWorkPage({params: {pageId: current, pageSize}, data: {...query, publicSea: 'public_seat'}}).then((res: any) => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const onBatchGetClue = ({selectedRowKeys}) => {
    getClue(selectedRowKeys)
  }

  // 呼叫公海-领取线索
  const getClue = (clueIds) => {
    if (state.clueBtnLoading) return
    setState({clueBtnLoading: true})
    callBatchReceive({clueIds})
        .then((res: any) => {
          listRef.current.reload()
          message.success(res?.message || '操作成功')
        })
        .finally(() => {
          setState({clueBtnLoading: false})
        })
  }

  const onCall = (record) => {
    console.log(record)
    setState({callModalOpen: true, callClueId: record.id})
  }

  const extension = {
    request: {fetchList},
    events: {onBatchGetClue},
    auth: getAuth(),
    rowKey: 'id',
    customRender: {
      clueIdRender(text: any, record: any, index: any) {
        let label = text
        if (record?.sourceFlag == 'CONTENT_SHARING') {
          label += `-内`
        }
        return (
            <SIDRender
                id={label}
                onClick={() => {
                  openInNewTab(`/mos/saleOp/salesWorkBench/salesWorkBenchDetail/${record.id}?authKey=call`)
                }}
            />
        )
      },
      checkPhone(text: any, record: any, index: any) {
        return (
            <div className={styles.flexStart}>
              <CheckThePhone
                  clueId={record.id}
                  initValue={text}
                  auth="callViewPhone"
              />
             {/* {text && state.isSeat && <div className={styles.callIconBox} onClick={() => onCall(record)}>
                <PhoneFilled className={styles.callIcon}/>拨号</div>}*/}
            </div>
        )
        //   salesWorkBench
      },
      stateRender(text) {
        return <Tag color='pink'>{text}</Tag>
      },
      nameRender(v, record) {
        return <div style={{display: 'flex'}}>
          <img style={{width: 20, height: 20, marginRight: 5}} src={record.salesAddQvFlag ? wx_add_ok : wx_add}/>
          {v}
        </div>
      },
      callStatusRender(v, record) {
        return <div>拨打/接通： {v || 0}/{record.successCount || 0}</div>
      },
      actionRender(_, record) {
        return <STableActions>
          <SActionBtn
              title="确认领取吗？"
              confirm
              auth="CallCluePickFromOcean"
              onClick={() => {
                getClue([record.id])
              }}
          >
            领取
          </SActionBtn>
        </STableActions>
      },
    },
  }

  return (
      <>
        <SLowcodeList config={{...config, name: props.listConfigName}} ref={listRef} searchMode="group" {...extension}/>
        {state.callModalOpen && <ClueCallModal open={state.callModalOpen} clueId={state.callClueId}
                                               fn={listRef.current.reload}
                                               onClose={() => setState({callModalOpen: false})}/>}
      </>
  )
}

export default CallPublicInfo
